import React from 'react';

import { useSettings } from 'app/main/components';
import { ViewTable } from 'app/main/components/page-layouts';
import { type ViewPageContentTabProps } from 'app/main/components/page-layouts/view/ViewPage';

import getKpisGoalsValuesTableColumns from '../KpisGoalsValuesTableColumns';

export default function KpisGoalsValuesTableTab(props: ViewPageContentTabProps) {
	const { settings, t } = useSettings('sys_kpis_goals');

	const columns = getKpisGoalsValuesTableColumns({ settings, t, updateRefresh: props.updateRefresh });

	return (
		<ViewTable
			id="kpiGoalsValuesView"
			module="sys_kpis_goals_values"
			columns={columns}
			refresh={props.refresh}
			updateRefresh={props.updateRefresh}
		/>
	);
}
